module.exports = {
  "marketName": "UK",
  "marketNameTracking": "UK",
  "locale": "en-GB",
  "legacyNearestGroupSearchUrl": "http://www.slimmingworld.co.uk/joining-a-group/nearest-group.aspx?",
  "publicUrl": "http://www.slimmingworld.co.uk",
  "pregnancyCTAUrl": "https://www.slimmingworld.co.uk/mums",
  "supportEmail": "online.support@slimmingworld.co.uk",
  "currencyCode": "GBP",
  "onlineMemberSupportPhoneNumber": "0344 892 0430",
  "technicalMemberSupportPhoneNumber": "0344 892 0431",
  "defaultCountry": "GB",
  "defaultOfferCopy": true,
  "textBasedGroupSearch": true,
  "dropDownBasedGroupSearch": false,
  "voucherPhoneNumber": "0344 892 0400",
  "groupEnquiriesNumber": "0344 897 8000",
  "headOfficeNumber": "0344 892 0400",
  "hasCyprusGroups": true,
  "hasGeolocationGroupSearch": true,
  "homepageDefaultVideo": true,
  "virtualGroups": true,
  "facebookBusinessVerification": "m33jr8o97ow7o0z405d85sxvhx8dy2",
  "oneTrustCookieConsentId": "28654904-ed42-44ac-acc1-99207a518450"
};